<template>
  <div>
    <div class='video-container' v-if="background">
      <video class='video-part background-video' ref="background-video" preload='auto' :src='background'></video>
      <div class='face-only' v-for="(part, part_index) in parts" :key="`part-${part_index}`">
        <video :src="part.video_url" preload='auto' :ref="`part-${part_index}`" v-show="current_part_index == part_index" class="video-part" @canplay="can_play" @timeupdate="timeupdate" :data-part_index='part_index'></video>
      </div>
    </div>

    <div v-else class='video-container'>
      <video v-for="(part, part_index) in parts" :key="`part-${part_index}`" :src="part.video_url" preload='auto' :ref="`part-${part_index}`" v-show="current_part_index == part_index" class="video-part" @canplay="can_play" @timeupdate="timeupdate" :data-part_index='part_index'></video>
    </div>

    <!-- <b-button @click='play'>Play</b-button> -->
  </div>
</template>

<script>
export default {
  props: ['parts', 'background'],
  data() {
    return {
      currentTime: 0,
      paused: true,
      duration: null,
      current_part_index: 0,
      // video_src: 'https://dev-assets.getvidon.com/project/123/fij7r7l7xtdef2pzeycid8.mp4',
      // parts: [
      //   {"type": "video", "video_url": "https://dev-assets.getvidon.com/project/123/drvr7jhuv4jtp0ds56i3k.mp4"},
      //   {"type": "video", "video_url": "https://dev-assets.getvidon.com/project/123/73g3zxyg0yc4q40j6voyow.mp4"},
      //   {"type": "video", "video_url": "https://dev-assets.getvidon.com/project/123/fij7r7l7xtdef2pzeycid8.mp4"}
      // ],
      parts_metadata: [],
      // background: 'https://dev-assets.getvidon.com/project/123/fij7r7l7xtdef2pzeycid8.mp4'
    }
  },
  methods: {
    play() {
      let first_part = this.$refs[`part-0`][0]
      this.currentTime = 0
      first_part.currentTime = 0
      this.current_part_index = 0
      first_part.play()
      this.$emit('playing')
      this.paused = false

      // Reset all the parts
      for (let part_index in this.parts) {
        if (part_index == 0) continue // Skip first as playing
        let part = this.$refs[`part-${part_index}`][0]
        part.currentTime = 0
        part.load()
      }

      if (this.background) {
        let background_video = this.$refs[`background-video`]
        background_video.currentTime = 0
        background_video.play()
      }
    },
    on_video_end(part_index, next_part_index) {
      if (next_part_index) {
        let next_part = this.$refs[`part-${next_part_index}`][0]

        next_part.play()
        this.current_part_index = next_part_index

        let current_part = this.$refs[`part-${part_index}`][0]
        current_part.currentTime = 0 // Reset the time
      } else {
        this.paused = true
        this.$emit('ended')
        this.$emit('pause')
      }
    },
    can_play(evt) {
      this.parts_metadata[evt.target.dataset.part_index].canplay = true
      this.parts_metadata[evt.target.dataset.part_index].duration = evt.target.duration

      let all_true = true
      let total_duration = null
      for (let part of this.parts_metadata) {
        if (!part.canplay) {
          all_true = false
          break
        } else {
          total_duration += part.duration
        }
      }

      if (all_true) {
        this.duration = total_duration
        this.$emit('canplay')
      }
    },
    timeupdate(evt) {
      let part_index = evt.target.dataset.part_index
      let part = this.$refs[`part-${part_index}`][0]

      let previous_duration = 0
      for (let i in this.parts_metadata) {
        if (i == part_index) {
          break
        }

        previous_duration = previous_duration + this.parts_metadata[i].duration
      }

      if (evt.target.currentTime > 0 && part_index == this.current_part_index) {
        this.currentTime = previous_duration + evt.target.currentTime
        this.$emit('timeupdate')
      }
    }
  },
  mounted() {
    for (let part_index in this.parts) {
      this.parts_metadata.push({duration: null, canplay: false})
      let next_part_index = null
      if (part_index < this.parts.length-1) {
        next_part_index = Number(part_index) + 1
      }

      let part = this.$refs[`part-${part_index}`][0]
      part.addEventListener('ended', this.on_video_end.bind(this, part_index, next_part_index), false);
    }
  }
}
</script>
<!--
TODO:
- If background is shorter then video?
- If background is longer then video? -->

<style>

.video-container {
  position: relative;
  /* width: 480px; */
  /* height: 360px; */
  margin: auto;
}

.video-part {
  width: auto;
  height: 100%;
  position: relative;
}

.face-only {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  left: 20px;
  bottom: 20px;
  position: absolute;
  overflow: hidden;
  border: 1px solid #FFF;
}

/* As we know the aspet ratio is 4/3 */
.face-only > .video-part {
  left: -12.5%;
}

.background-video {
  position: relative;
  width: 100%;
}

</style>
